// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3rEpm","buttons":"RemoveExpirationActionButtons_buttons__1GfN-"};